import { defineMessages } from 'react-intl';
export default defineMessages({
  logout: {
    id: 'common.nav.logout',
    defaultMessage: 'Logout'
  },
  site: {
    id: 'common.patientHeader.site',
    defaultMessage: 'Site of Admission'
  },
  phone: {
    id: 'common.patientHeader.phone',
    defaultMessage: 'Phone'
  },
  diagnosis: {
    id: 'common.patientHeader.diagnosis',
    defaultMessage: 'Diagnosis'
  },
  allergies: {
    id: 'common.patientHeader.allergies',
    defaultMessage: 'Allergies'
  },
  insurance: {
    id: 'common.patientHeader.insurance',
    defaultMessage: 'Insurance'
  },
  referredBy: {
    id: 'common.patientHeader.referredBy',
    defaultMessage: 'Referred By'
  },
  phys: {
    id: 'common.patientHeader.phys',
    defaultMessage: 'Phys'
  },
  dob: {
    id: 'common.patientHeader.dob',
    defaultMessage: 'DOB'
  },
  city: {
    id: 'common.patientHeader.city',
    defaultMessage: 'City'
  },
  street: {
    id: 'common.patientHeader.street',
    defaultMessage: 'Street'
  },
  state: {
    id: 'common.patientHeader.state',
    defaultMessage: 'State'
  },
  location: {
    id: 'common.patientHeader.location',
    defaultMessage: 'LOC'
  },
  zip: {
    id: 'common.patientHeader.zip',
    defaultMessage: 'Zip'
  },
  at: {
    id: 'common.patientHeader.at',
    defaultMessage: 'at'
  },
  to: {
    id: 'common.patientHeader.to',
    defaultMessage: 'to'
  },
  from: {
    id: 'common.patientHeader.from',
    defaultMessage: 'from'
  },
  asof: {
    id: 'common.patientHeader.asof',
    defaultMessage: 'as of'
  },
  unknown: {
    id: 'common.patientHeader.unknown',
    defaultMessage: 'Unknown'
  },
  referred: {
    id: 'common.patientHeader.referred',
    defaultMessage: 'Referred'
  },
  admitted: {
    id: 'common.patientHeader.admitted',
    defaultMessage: 'Admitted'
  },
  discharged: {
    id: 'common.patientHeader.discharged',
    defaultMessage: 'Discharged'
  },
  reason: {
    id: 'common.patientHeader.reason',
    defaultMessage: 'Reason'
  },
  noPhysician: {
    id: 'common.patientHeader.noPhysician',
    defaultMessage: 'No physician'
  },
  gender: {
    id: 'common.patientHeader.gender',
    defaultMessage: 'Gender'
  },
  county: {
    id: 'common.patientHeader.county',
    defaultMessage: 'County'
  },
  address: {
    id: 'common.patientHeader.address',
    defaultMessage: 'Patient Address'
  },
  currentLocation: {
    id: 'common.patientHeader.currentLocation',
    defaultMessage: 'Current Location'
  },
  physician: {
    id: 'common.patientHeader.physician',
    defaultMessage: 'Physician'
  },
  idgTeam: {
    id: 'common.patientHeader.idgTeam',
    defaultMessage: 'IDG Team'
  },
  dnr: {
    id: 'common.patientHeader.dnr',
    defaultMessage: 'DNR'
  },
  primaryPolicyNumber: {
    id: 'common.patientHeader.primaryPolicyNumber',
    defaultMessage: 'Primary Payer / Policy'
  },
  dischargeReason: {
    id: 'common.patientHeader.dischargeReason',
    defaultMessage: 'Discharge Reason'
  },
  cert: {
    id: 'common.patientHeader.cert',
    defaultMessage: 'Cert'
  },
  printedOn: {
    id: 'common.patientHeader.printedOn',
    defaultMessage: 'Printed on'
  },
  patient: {
    id: 'common.patientHeader.patient',
    defaultMessage: 'Patient'
  },
  naAcronym: {
    id: 'common.patientHeader.naAcronym',
    defaultMessage: 'N/A'
  },
  currentCert: {
    id: 'common.patientHeader.currentCert',
    defaultMessage: 'Current Cert'
  },
  nextCert: {
    id: 'common.patientHeader.nextCert',
    defaultMessage: 'Next Cert'
  },
  patientName: {
    id: 'common.patientHeader.patientName',
    defaultMessage: 'Patient Name'
  }
});